export default __webpack_public_path__ + "static/media/seal.3044b948.png";